<template>
  <div :class="['search-box-container', { 'dense': dense }]">
    <form @submit.prevent="commitSearch()">
      <v-text-field
        v-model.trim="searchInput"
        :disabled="disabled"
        :placeholder="placeholder"
        dense
        :outlined="!dense"
        :solo="dense"
        :filled="dense"
        color="secondary"
        hide-details
        @keyup.native.enter="commitSearch()"
        @click:append="commitSearch()">
        <template #append>
          <v-icon>
            mdi-magnify
          </v-icon>
        </template>
      </v-text-field>
      <!-- <div class="ml-2">
        <v-btn
          color="secondary"
          :disabled="disabled"
          type="submit">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </div> -->
    </form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    searchInput: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    commitSearch () {
      this.$emit('on-search', this.searchInput)
    }
  }
}
</script>

<style scoped>
.search-box-container form {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>

<style>
.search-box-container.dense .v-input__control {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.search-box-container.dense .v-input__slot {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
</style>
